import type { tInitialScreen } from "@/config";
import { tLocale } from "./env";
import type { tGeoPoint, tMastersSearchLocation } from "./geo";

export type tUserPrefs = {
  initial_screen: Maybe<tInitialScreen>;
  day_overall_stats_notification: {
    disabled: boolean;
    minutes: number;
  };
  todo_completion_prob_tip: boolean;
  daily_sleep: number;
  theme?: string;
  color_scheme?: "dark" | "light";
  masters_search_loc?: tMastersSearchLocation;
};

export enum eUserRole {
  ADMIN = "admin",
  SALOON_OWNER = "saloonOwner",
  SALOON_ADMIN = "saloonAdmin",
}
export enum eAppUsageMode {
  STD = "std",
  BUSINESS = "business",
}

export type tUser = {
  _id: string;
  master: string;
  email?: string;
  /**
   * {@link https://yandex.ru/support/metrica/objects/get-client-id.html}
   */
  ym_client_id?: string;
  masters: string[];
  contacts: string[];
  phone?: string;
  avatar?: string;
  bio?: string;
  google_id?: number;
  online: boolean;
  online_at: string;
  vk_id?: number;
  first_name: string;
  last_name?: string;
  middle_name?: string;
  sex: boolean;
  location: tGeoPoint;
  location_hr: string;
  timezone: string;
  locale: tLocale;
  show_activities: tUserActivityTypes;
  created_at: string;
  has_sms_acc: boolean;
  currency: string;
  premium?: boolean;
  roles: eUserRole[];
  app_usage_mode?: eAppUsageMode;
  is_client?: boolean;
  //enabled_features?: EFeature[];
  prefs?: tUserPrefs;
  is_banned?: boolean;
};

export type tUserActivityTypes = ["Review", "Portfolio"];
export type tUserActivity = {
  actor: string;
  entity_ref: tUserActivityTypes[number];
  entity: string;
  meta: any;
  date: string;
};
